export default __webpack_public_path__ + "static/media/aunty.6a75a9ff.jpeg";